import type { ReactNode } from "react";

interface PageShellProps {
	title?: string;
	subtitle?: string;
	actions?: ReactNode;
	children: ReactNode;
	maxWidth?: string;
	bare?: boolean;
}

/** Consistent page container: centered column with a title row. */
export function PageShell({
	title,
	subtitle,
	actions,
	children,
	maxWidth = "max-w-6xl",
	bare = false,
}: PageShellProps) {
	if (bare) return <>{children}</>;

	return (
		<div className={`mx-auto w-full ${maxWidth} px-4 py-6`}>
			{(title || actions) && (
				<div className="mb-6 flex items-end justify-between gap-4">
					<div>
						{title && <h1 className="text-2xl font-black tracking-tight">{title}</h1>}
						{subtitle && <p className="mt-1 text-sm text-muted">{subtitle}</p>}
					</div>
					{actions}
				</div>
			)}
			{children}
		</div>
	);
}
